import { Center, FlexProps, forwardRef } from '@chakra-ui/react'
import React from 'react'

export const Container = forwardRef((props: FlexProps, ref: React.ForwardedRef<HTMLDivElement>) => (
  <Center ref={ref} width="100%" flexFlow="column" pos="relative" {...props} />
))
